import { useFormContext } from 'react-hook-form';
import { getIsSsoEnabled } from '../../../../api/auth/auth.api';
import { LoginFormType, LoginFormValues } from '../types';
import { StyledLoginButton } from './helpers';
import useNotifications from '../../../../_lib/notifications/useNotifications';

const IntakeForm = () => {
  const methods = useFormContext<LoginFormValues>();
  const [username, isLoading] = methods.watch(['username', 'sso.isLoading']);
  const notifications = useNotifications();

  const handleContinue = async () => {
    const isValid = await methods.trigger();

    if (!isValid) {
      return;
    }

    methods.setValue('sso.isLoading', true);

    try {
      const res = await getIsSsoEnabled(username);

      const isEnabled = res.data.enabled;
      const nextFormType = isEnabled ? LoginFormType.SSO : LoginFormType.EMAIL;

      methods.setValue('sso.loginFormType', nextFormType);
      methods.setValue('sso.enabled', isEnabled);
    } catch (err) {
      notifications.error(
        'An error occurred while checking if SSO is enabled.',
        <>Please enter your email to try again.</>
      );
      methods.setValue('sso.loginFormType', LoginFormType.EMAIL);
    } finally {
      methods.setValue('sso.isLoading', false);
      methods.reset(
        {
          ...methods.getValues(),
        },
        { keepDirty: false }
      );
    }
  };

  return (
    <StyledLoginButton
      size="large"
      fullWidth
      disableRipple
      onClick={handleContinue}
      disabled={username.trim() === '' || isLoading}
    >
      Continue
    </StyledLoginButton>
  );
};

export default IntakeForm;
